/**
 * "ResizeObserver loop completed with undelivered notifications" is the
 * browser saying it put off a resize notification to the next frame. It is
 * not an error and nothing breaks: the spec defines it as a warning
 * (https://github.com/WICG/resize-observer/issues/38).
 *
 * MUI 5.15's auto-growing text fields (TextareaAutosize) cause it whenever
 * their width changes, which happens when a docked Genie resizes the page. MUI
 * defers the resize only in tests; until the component library moves to a
 * version that does it everywhere, this keeps the notice from reaching the
 * development error overlay and Sentry. Only this exact message is filtered.
 */
const BENIGN_MESSAGES = new Set([
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
]);

export const isBenignBrowserError = (message: string): boolean =>
  BENIGN_MESSAGES.has(message);

/** Registered before anything else listens, so later listeners never see it. */
export const ignoreBenignBrowserErrors = () => {
  window.addEventListener(
    "error",
    (event) => {
      if (isBenignBrowserError(event.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    { capture: true }
  );
};
